module.exports = __webpack_public_path__ + "static/media/Icons_add-circle.067023a1.svg";